var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Tamaños de Spots","storeName":"Size_spots","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/amenities","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/size_spots'
      },
      {
        text: 'Tamaños de Spots',
        disabled: false,
        href: '#'
      },
    ]},scopedSlots:_vm._u([{key:"icon",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(item.icon)?_c('v-list-item-avatar',[_c('img',{attrs:{"src":item.icon,"alt":""}})]):_vm._e()],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }